import { useEffect, useState } from "react";

const currencyFormatter = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
});

const StoreProductCard = ({ product, variant = "grid" }) => {
  const images = Array.isArray(product.images) ? product.images : [];
  const imageCount = images.length;
  const [activeImage, setActiveImage] = useState(0);

  const title = product.title || product.name;
  const description = product.description || product.subtitle;
  const price = product.price ?? null;
  const promotionalPrice = product.promotionalPrice ?? null;
  const originalPrice = product.originalPrice ?? (promotionalPrice !== null ? price : null);
  const points = product.points ?? null;
  const currentPrice = promotionalPrice !== null && promotionalPrice !== undefined ? promotionalPrice : price;
  const hasCurrentPrice = currentPrice !== null && currentPrice !== undefined && Number.isFinite(Number(currentPrice));
  const hasOriginalPrice =
    originalPrice !== null &&
    originalPrice !== undefined &&
    currentPrice !== null &&
    currentPrice !== undefined &&
    Number(originalPrice) > Number(currentPrice);
  const hasPoints = points !== null && points !== undefined && Number.isFinite(Number(points));
  const badgeText = product.badge || (hasOriginalPrice ? "Oferta" : hasPoints ? "Pontos" : "");

  useEffect(() => {
    setActiveImage(0);
  }, [imageCount]);

  useEffect(() => {
    if (imageCount <= 1) return undefined;

    const interval = window.setInterval(() => {
      setActiveImage((current) => (current + 1) % imageCount);
    }, 4000);

    return () => window.clearInterval(interval);
  }, [imageCount]);

  return (
    <article className={`store-product-card store-product-card--${variant}`}>
      <div
        className={`store-product-media ${images.length > 0 ? "has-images" : ""} tone-${product.tone || "midnight"}`}
      >
        {badgeText ? <span className="store-product-badge">{badgeText}</span> : null}

        {images.length > 0 ? (
          <>
            {images.map((image, index) => (
              <div
                key={image.id || `${title}-${index}`}
                className={`store-product-image-slide ${index === activeImage ? "is-active" : ""}`}
              >
                <img src={image.url} alt={title} />
              </div>
            ))}

            {images.length > 1 ? (
              <div className="store-product-image-dots">
                {images.map((image, index) => (
                  <button
                    key={`dot-${image.id || index}`}
                    type="button"
                    className={index === activeImage ? "is-active" : ""}
                    onClick={() => setActiveImage(index)}
                    aria-label={`Exibir imagem ${index + 1} de ${title}`}
                  />
                ))}
              </div>
            ) : null}
          </>
        ) : (
          <div className="store-product-art">
            <strong>{product.artLabel || title}</strong>
            {product.artSubLabel ? <span>{product.artSubLabel}</span> : null}
          </div>
        )}
      </div>

      <div className="store-product-body">
        {product.minOrder || product.delivery ? (
          <div className="store-product-topline">
            {product.minOrder ? <span>{product.minOrder}</span> : null}
            {product.delivery ? <span>{product.delivery}</span> : null}
          </div>
        ) : null}

        <h3>{title}</h3>
        {description ? <p>{description}</p> : null}

        <div className="store-product-footer">
          {hasCurrentPrice || hasPoints ? (
            <div className="store-product-pricing">
              {hasCurrentPrice ? (
                <strong>{currencyFormatter.format(Number(currentPrice))}</strong>
              ) : null}
              {hasOriginalPrice ? <span>{currencyFormatter.format(Number(originalPrice))}</span> : null}
              {hasPoints ? <small>{Number(points)} pontos</small> : null}
            </div>
          ) : <div className="store-product-pricing empty" />}

          <button type="button" className="store-product-action">
            Adicionar ao carrinho
          </button>
        </div>
      </div>
    </article>
  );
};

export default StoreProductCard;
